import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';

@Injectable()
export class ActivityViewsService {
    baseUrl = '/activity-views';

    constructor( private http: ApiHttpClient ) { }

    updateOrCreate(borrowerId: number, type: string) {
        const body = {
            borrowerId: borrowerId,
            type: type
        };
        return this.http.post(`${environment.API_URL}/activity-views`, body);
    }

}
